import { createContext, useContext, useState, useEffect } from "react";
import api from "@/lib/api";

const ThemeContext = createContext(null);
const STORAGE_KEY = "ikavio-mode";
const normalize = (v) => (v === "dark" ? "dark" : "light");

export function ThemeProvider({ children }) {
  const [theme, setThemeState] = useState(() => normalize(localStorage.getItem(STORAGE_KEY)));

  const setTheme = (id) => {
    const v = normalize(id);
    setThemeState(v);
    api.put("/me/preferences", { theme: v }).catch(() => {});
  };

  const applyServerTheme = (id) => setThemeState(normalize(id));
  const toggle = () => setTheme(theme === "dark" ? "light" : "dark");

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    document.documentElement.classList.toggle("dark", theme === "dark");
    localStorage.setItem(STORAGE_KEY, theme);
  }, [theme]);

  return (
    <ThemeContext.Provider value={{ theme, setTheme, toggle, applyServerTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);
